import React from 'react';
import { NewLandingPage } from './pages/NewLandingPage';
// Google Tag Manager noscript fallback component
const GTMNoScript = () => <noscript data-id="element-0">
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KSNWGS2V" height="0" width="0" style={{
    display: 'none',
    visibility: 'hidden'
  }} data-id="element-1" />
  </noscript>;
export function App() {
  return <>
      <GTMNoScript data-id="element-2" />
      <NewLandingPage data-id="element-3" />
    </>;
}